export default (state = {}, { type, payload }) => {
  switch (type) {
    case 'LEFT_TOOLBAR_EXPAND':
      return {
        expanded: true,
        dialog: payload.dialog,
        editable: payload.editable ? payload.editable : null,
        mapObj: payload.mapObj ? payload.mapObj : null,
      }
    case 'LEFT_TOOLBAR_COLLAPSE':
      return {
        expanded: false,
        dialog: null,
        editable: null,
        mapObj: null
      }
    case 'LOGOUT':
      return {
        expanded: false,
        dialog: null,
        editable: null
      }
    default:
      return state
  }
}